
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1ol5m_dxw9c_9"
};
  